import { useState } from "react";
import {
  ArrowLeftRight,
  PlusCircle,
  ThreeDotsVertical,
} from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import Table, { Column } from "../../../Components/Tables/Table";
import { stockTransferDropDownData } from "../../../Data/dropdownDataList";
import {
  transferoverviewcompletedlist,
  transferoverviewinprogresslist,
  transferoverviewlist
} from "../../../Data/testData";
import PageHeader from "../../../Layout/PageHeader";
import Tabs from "../../../Shared/Tab/Tab";
import ImportLayout from "../../../Layout/ImportLayout";
import ExportLayout from "../../../Layout/ExportLayout";
import CommonModal from "../../../Components/Modals/CommonModal";


export default function TransferOverview() {
  const pageName = "Stock Transfer";
  const navigation = useNavigate();
  const [showModalForImportAndExport, setShowModalForImportAndExport] =
  useState({
    importModal: false,
    exportModal: false,
  });
  const [isAddButtonDisable, setAddButtonDisable] = useState(false);
  const [showRowClicked, setShowRowClicked] = useState(false);
  console.log(showRowClicked);
  const handelDetailScreenAction = (data: any) => {
    navigation(`/inventory/stock-transfer/transfer-details/${data.transferNum}`)
   };
  const handelInactiveAction = (data: any) => { };
  const handelDeleteAction = (data: any) => { };
  const handelSelectRows = (selectedRow: Set<number>) => {
    setAddButtonDisable(selectedRow.size > 0);
  };

  const handleRowClick = (data: any) => {
    if (showRowClicked == false) {
      navigation(
        `/inventory/stock-transfer/transfer-details/${data.transferNum}`
      );
    }
  };
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShow(!show);

  const columns: Column[] = [
    {
      name: "Transfer Number",
      selector: (row: { transferNum: string }) => (
        <span onClick={() => handleRowClick(row)} className="cursor-pointer text-primary " >
          {row.transferNum}
        </span>
      ),
      enableSorting: true
    },
    {
      name: "Created By ",
      selector: (row: { createdBy: string }) => row.createdBy,
      enableSorting: true
    },
    {
      name: "Created on",
      selector: (row: { createOn: string }) => row.createOn,
      enableSorting: true
    },
    {
      name: "No. of Lines",
      selector: (row: { noOfLines: string }) => row.noOfLines,
      enableSorting: true
    },
    {
      name: "Transfer By",
      selector: (row: { transferBy: number }) => row.transferBy,
      enableSorting: true
    },
    {
      name: "Assigned To",
      selector: (row: { assignedTo: number }) => row.assignedTo,
      enableSorting: true
    },
    {
      name: "Status",
      selector: (row: { status: string }) => {
        return row.status === "New" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-blue">
            New
          </span>
        ) : row.status === "Backorder" ? (
          <span className="badge text asn-overview-status w-70 asn-overview-status-border-red">
            Backorder
          </span>
        ) : row.status === "Completed" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-green">
            Completed
          </span>
        ) : row.status === "Ready to Check-in" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-blue">
            Ready to Check-in
          </span>
        ) : row.status === "Ready to Unload" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-blue">
            Ready to Unload
          </span>
        ) : row.status === "Ready to Receive" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-blue">
            Ready to Receive
          </span>
        ) : row.status === "In Progress" ? (
          <span className="badge asn-overview-status w-70 asn-overview-status-border-yellow">
            In Progress
          </span>
        ) : (
          <></>
        );
      },
      enableSorting: true
    },
    {
      name: (
        <>
          <ArrowLeftRight className="me-2" /> <PlusCircle />
        </>
      ),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none list-ellipse-ms"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={() => setShowRowClicked(true)}
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelDetailScreenAction(row)}
            >
              Detail Screen
            </li>
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelInactiveAction(row)}
            >
              Assign
            </li>
          </ul>
        </>
      ),
    },
  ];

  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log('Page changed to:', page);
  };
  const tabs = [
    {
      order: 0,
      label: "New | " + transferoverviewlist.length,
      content: (
        <Table
          columns={columns}
          data={transferoverviewlist}
           pagination={{
          recordsPerPage: 15,
          totalRecords: transferoverviewlist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
          CheckboxStatus={true}
          enableSorting={true}
        />
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "In Progress | " + transferoverviewinprogresslist.length,
      content: (
        <Table
          columns={columns}
          data={transferoverviewinprogresslist}
           pagination={{
          recordsPerPage: 15,
          totalRecords: transferoverviewinprogresslist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
          handleRowClick={handleRowClick}
          CheckboxStatus={true}
          enableSorting={true}
        />
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Completed | " + transferoverviewcompletedlist.length,
      content: (
        <Table
          columns={columns}
          data={transferoverviewcompletedlist}
           pagination={{
          recordsPerPage: 15,
          totalRecords: transferoverviewcompletedlist.length,
          onCurrentPageChange: onCurrentPageChange
        }}
          handleRowClick={handleRowClick}
          CheckboxStatus={true}
          enableSorting={true}
        />
      ),
      visibility: true,
      status: true,
      
    },
  ];

  //   {
  //     order: 0,
  //     label: "New | " + inboundASNOverviewNewData.length,
  //     content: (
  //       <Table
  //         columns={columns}
  //         data={inboundASNOverviewNewData}
  //       //   handleRowClick={handleRowClick}
  //       />
  //     ),
  //     visibility: true,
  //     status: true,
  //   },
  //   {
  //     order: 1,
  //     label: "In Progress | " + inboundASNOverviewInProgressData.length,
  //     content: (
  //       <Table
  //         columns={columns}
  //         data={inboundASNOverviewInProgressData}
  //       //   handleRowClick={handleRowClick}
  //       />
  //     ),
  //     visibility: true,
  //     status: false,
  //   },
  //   {
  //     order: 2,
  //     label: "Completed | " + inboundASNOverviewCompletedData.length,
  //     content: (
  //       <Table
  //         columns={columns}
  //         data={inboundASNOverviewCompletedData}
  //       //   handleRowClick={handleRowClick}
  //       />
  //     ),
  //     visibility: true,
  //     status: true,
  //   },
  // ];
  return (
    <>
      <PageHeader
        // addUrl="/account/client/items/add"
        listUrl="/account/client/items"
        gridUrl=""
        name="Assign"
        isShowUpload={true}
        isDropdown={true}
        dropDownData={stockTransferDropDownData}
        setShowModalForImportAndExport={setShowModalForImportAndExport}
        showModalForImportAndExport={showModalForImportAndExport}
      />

      <div className="clearfix"></div>

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div>
        <Tabs  tabs={tabs} isCheckbox={false} />
      </div>

      <div className="inbound-CheckIn-Table-Main-Div"></div>
      <CommonModal
        show={showModalForImportAndExport.importModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, importModal: false };
        })}
        heading={"Import File"}
        content={<ImportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
      <CommonModal
        show={showModalForImportAndExport.exportModal}
        handleClose={() => setShowModalForImportAndExport((preValue: any) =>{
          return {...preValue, exportModal: false };
        })}
        heading={"Export"}
        content={<ExportLayout handleClose={handleShow}/>}
        modalSize="modal-lg"
        footerButtonsActive={false}
        customClassNameForBody=""
        customClassNameForHeader="create-kit-orders"
      />
    </>
  );
}
